import { SubAccount } from '@dev/ee-api/ee-api-models';
import { ActionCreator } from 'redux';
import { GetSubAccountsAction, GetSubAccountsSuccessAction, SubAccountErrorAction } from './types';

export const GetSubAccounts: ActionCreator<GetSubAccountsAction> = (
    limit?: number,
    offset?: number
): GetSubAccountsAction => ({
    type: '@@subaccounts/GET_SUBACCOUNTS',
    payload: {
        limit,
        offset,
    },
});

export const GetSubAccountsSuccess: ActionCreator<GetSubAccountsSuccessAction> = (
    list: SubAccount[]
): GetSubAccountsSuccessAction => ({
    type: '@@subaccounts/GET_SUBACCOUNTS_SUCCESS',
    payload: {
        list,
    },
});

export const SubAccountsError: ActionCreator<SubAccountErrorAction> = (): SubAccountErrorAction => ({
    type: '@@subaccounts/SUBACCOUNTS_ERROR',
});
